const rawApiBaseUrl = "https://techsolutionsservice.ustdev.com/api/track-on/";


export const API_BASE_URL = rawApiBaseUrl.endsWith("/")
  ? rawApiBaseUrl
  : `${rawApiBaseUrl}/`;

  export const BASE_PROJECTS_API_URL = `${API_BASE_URL}projects`;




export const PROJECT_SEARCH_API_URL = `${API_BASE_URL}projects/search`;



export const GET_PROJECT_BY_ID_URL = (projectId) =>
  `${API_BASE_URL}projects/${encodeURIComponent(projectId)}`;

export const LOGIN_API_URL = `${API_BASE_URL}auth/login`;
export const REGISTER_API_URL = `${API_BASE_URL}user/register`;
export const REMEMBER_ME_STORAGE_KEY = "track_on_remember_user";
export const APPROVAL_USERS_API_PROXY_URL = `${API_BASE_URL}users-approval`;
export const DASHBOARD_OVERVIEW_API_URL = `${API_BASE_URL}dashboard/overview`;
export const LEADERSHIP_ATTENTION_DASHBOARD_API_URL = `${API_BASE_URL}dashboard/leadership-attention`;
export const LEADERSHIP_ATTENTION_DOWNLOAD_API_URL = `${API_BASE_URL}dashboard/leadership-attention/download`;
export const SECURITY_QUESTIONS_API_URL = `${API_BASE_URL}security-questions`;
export const FORGOT_PASSWORD_API_URL = `${API_BASE_URL}forgot-password`;
export const CHANGE_PASSWORD_API_URL = `${API_BASE_URL}user/change-password`;
export const GET_SECURITY_QUESTION_API_BASE_URL = `${API_BASE_URL}forgot-password/security-question`;
export const SOW_UPLOAD_API_URL = `${API_BASE_URL}sow/upload`;
export const ADD_PROJECT_API_URL = `${API_BASE_URL}projects/add`;
export const PROJECT_UPDATE_API_BASE_URL = `${API_BASE_URL}projects/update`;
export const DELETE_PROJECT_API_URL = (projectId) =>
  `${API_BASE_URL}projects/${encodeURIComponent(projectId)}`;
export const APPROVAL_USERS_API_URL = `${API_BASE_URL}users-approval`;
export const USER_UPDATE_API_BASE_URL = `${API_BASE_URL}users-approval/approve`;
export const APPROVAL_USERS_ACCOUNT_API_URL = `${API_BASE_URL}users-approval/account`;
export const PROJECTS_BY_ACCOUNT_API_URL = `${API_BASE_URL}projects/by-account`;
export const ADMIN_RESET_PASSWORD_API_URL = `${API_BASE_URL}admin-reset-password`;
export const USER_DEACTIVATE_API_URL = `${API_BASE_URL}user/deactivate`;
export const MILESTONES_API_URL = `${API_BASE_URL}milestones`;
export const PROJECT_INVOICE_STATUS_UPDATE_API_URL = `${API_BASE_URL}projects/invoice/status-update`;
export const INVOICE_UPLOAD_API_URL = `${API_BASE_URL}invoice/upload`;
//export const INVOICE_FILTER_API_URL = `${API_BASE_URL}invoices/filter`;
export const INVOICE_FILTER_API_URL = `${API_BASE_URL}milestones`;
export const PROJECT_IMPORT_API_URL = `${API_BASE_URL}projects/upload`;
export const PROJECT_HEALTH_IMPORT_API_URL = `${API_BASE_URL}project-review/upload/project-health-excel`;
export const PROJECT_REVIEW_HEALTH_API_URL = `${API_BASE_URL}project-review/project-health-excel`;
export const PROJECT_ALERT_NOTIFICATIONS_API_URL = `${API_BASE_URL}notifications/expired-active`;
export const NOTIFICATIONS_BASE_API_URL = `${API_BASE_URL}notifications`;
export const NOTIFICATIONS_ALL_API_URL = `${NOTIFICATIONS_BASE_API_URL}`;
export const NOTIFICATIONS_UNREAD_COUNT_API_URL = `${NOTIFICATIONS_BASE_API_URL}/unread-count`;
export const NOTIFICATIONS_COUNTS_API_URL = `${NOTIFICATIONS_BASE_API_URL}/counts`;
export const NOTIFICATIONS_READ_API_URL = `${NOTIFICATIONS_BASE_API_URL}/read`;
export const NOTIFICATION_DELETE_API_URL = (id) => `${NOTIFICATIONS_BASE_API_URL}/${id}`;
export const GET_ALL_ROLES_API_URL = `${API_BASE_URL}roles`;
export const MILESTONE_STATUS_UPDATE_API_URL = `${API_BASE_URL}milestones/update-status`;
export const CURRENCY_CONFIGURATION_LIST_API_URL = `${API_BASE_URL}admin/configurations/currency/projects`;
export const CURRENCY_CONFIGURATION_SAVE_API_URL = `${API_BASE_URL}admin/configurations/currency`;
export const CURRENCY_CONFIGURATION_PROJECT_API_URL = `${API_BASE_URL}admin/configurations/currency/project`;
export const GET_MANAGERS_API_URL = `${API_BASE_URL}managers`;

export const ACCOUNTS_API_URL = `${API_BASE_URL}admin/accounts`;

  export const ALL_ACCOUNTS_API_URL =  `${API_BASE_URL}admin/accounts/account-status`;
 

export const CURRENCY_CONFIGURATION_API_URL = `${API_BASE_URL}configuration/currency`;

export const CURRENCY_CONFIGURATION_GET_API_URL = `${API_BASE_URL}admin/configurations/currency`;
export const CURRENCY_CONFIGURATION_CREATE_API_URL = `${API_BASE_URL}admin/configurations/currency`;
export const CURRENCY_CONFIGURATION_UPDATE_API_URL = `${API_BASE_URL}admin/configurations/currency`;
export const BUSINESS_AREA_SETTINGS_API_URL = `${API_BASE_URL}settings/business-domains`;

export const SECURITY_QUESTION_ADD_API_URL = `${API_BASE_URL}users-approval/addQuestion`;
export const SECURITY_QUESTION_DELETE_API_BASE_URL = `${API_BASE_URL}users-approval/delete`;
export const PROJECT_REVIEW_BASE_URL =
  `${API_BASE_URL}project-review`;

export const DELETE_PROJECT_REVIEW_URL = (projectId) =>
  `${PROJECT_REVIEW_BASE_URL}/${projectId}`;

export const UPDATE_PROJECT_REVIEW_STATUS_URL = (projectId) =>
  `${PROJECT_REVIEW_BASE_URL}/${projectId}/status`;

export const GET_PROJECT_COMMENTS_URL = (projectId) =>
  `${PROJECT_REVIEW_BASE_URL}/${projectId}/comments`;

export const ADD_PROJECT_COMMENT_URL = (projectId) =>
  `${PROJECT_REVIEW_BASE_URL}/${projectId}/comments`;

export const UPDATE_PROJECT_COMMENT_URL = (
  projectId,
  commentId
) =>
  `${PROJECT_REVIEW_BASE_URL}/${projectId}/comments/${commentId}`;

export const DELETE_PROJECT_COMMENT_URL = (
  projectId,
  commentId
) =>
  `${PROJECT_REVIEW_BASE_URL}/${projectId}/comments/${commentId}`;

export const GET_PROJECT_ACTIONS_URL = (projectId) =>
  `${PROJECT_REVIEW_BASE_URL}/${projectId}/actions`;

export const ADD_PROJECT_ACTION_URL = (projectId) =>
  `${PROJECT_REVIEW_BASE_URL}/${projectId}/actions`;

export const UPDATE_PROJECT_ACTION_URL = (
  projectId,
  actionId
) =>
  `${PROJECT_REVIEW_BASE_URL}/${projectId}/actions/${actionId}`;

export const DELETE_PROJECT_ACTION_URL = (
  projectId,
  actionId
) =>
  `${PROJECT_REVIEW_BASE_URL}/${projectId}/actions/${actionId}`;

export const GET_PROJECT_VALUE_ADDS_URL = (projectId) =>
  `${PROJECT_REVIEW_BASE_URL}/${projectId}/value-add`;

export const ADD_PROJECT_VALUE_ADDS_URL = (projectId) =>
  `${PROJECT_REVIEW_BASE_URL}/${projectId}/value-adds`;

export const PATCH_PROJECT_VALUE_ADD_URL = (
  projectId,
  valueAddId,
) => `${PROJECT_REVIEW_BASE_URL}/${projectId}/value-add/${valueAddId}`;

export const UPLOAD_WSR_FILE_URL = (projectId) =>
  `${API_BASE_URL}projects/${projectId}/wsr/upload`;

export const LIST_WSR_FILES_URL = (projectId) =>
  `${API_BASE_URL}projects/${projectId}/wsr/list`;

export const DOWNLOAD_WSR_FILE_URL = (projectId, fileId) =>
  `${API_BASE_URL}projects/${projectId}/wsr/download/${fileId}`;
export const PROJECT_HEALTH_EXCEL_DOWNLOAD_API_URL =
  `${API_BASE_URL}project-review/download-all-excel`;
export const SHAREPOINT_WSR_FOLDER_URL =
  "https://ustglobal.sharepoint.com/teams/Act-walmart/WALM-1101-01-02/Work%20In%20Progress/Forms/AllItems.aspx";

export const SHAREPOINT_BASE_PATH =
  "/teams/Act-walmart/WALM-1101-01-02/Work In Progress/Back2Work";

  export const QUERY_KEYS = {
  projects: "projects",
} ;

export const MILESTONE_INVOICE_CONSTANTS={
  UPDATE_INVOICE_STATUS_OPTIONS:[
       { value: "In Progress", label: "In Progress" },
                    { value: "Due", label: "Due" },
                    { value: "Invoice Submitted", label: "Invoice Submitted" },
                    { value: "Paid", label: "Paid" },
                    { value: "On Hold/Disputed", label: "On Hold/Disputed" },
                    { value: "Invoice Rejected", label: "Invoice Rejected" },
                    { value: "Not Submitted", label: "Not Submitted" },


]
  

}